import React from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import {Wrapper, Menu, Content} from './components';

const Footer = () => (
  <div>
    <Wrapper>
      <Grid>
        <Content>
          <Menu>
            <h3>Послуги</h3>
            <ul>
              <li><Link to="/health-management">Департамент охорони здоров’я</Link></li>
              <li><Link to="/news">Новини</Link></li>
              <li><Link to="/infocenter">Інфоцентр</Link></li>
              <li><Link to="/about">Про портал</Link></li>
            </ul>
          </Menu>
          <Menu>
            <h3>Департамент охорони здоров’я</h3>
            <ul>
              <li><Link to="/health-management/direction">Керівництво</Link></li>
              <li><Link to="/health-management/units">Підрозділи</Link></li>
              <li><Link to="/health-management/timetable">Графік прийому громадян</Link></li>
              <li><Link to="/health-management/experts">Головні позаштатні фахівці</Link></li>
            </ul>
          </Menu>
          <Menu>
            <h3>Інфоцентр</h3>
            <ul>
              <li><Link to="/infocenter/documents">Нормативно-правова база</Link></li>
              <li><Link to="/infocenter/projects">Проекти та програми</Link></li>
              <li><Link to="/infocenter/reforms">Медична реформа</Link></li>
              <li><Link to="/infocenter/procurements">Державні закупівлі</Link></li>
              <li><Link to="/infocenter/corruption">Боротьба з корупцією</Link></li>
              <li><Link to="/infocenter/faq">Часті питання та відповіді </Link></li>
              <li><Link to="/infocenter/communities">Громадські організації</Link></li>
            </ul>
          </Menu>
        </Content>
      </Grid>
    </Wrapper>
  </div>
)


export default Footer;



// WEBPACK FOOTER //
// ./src/system/footer/index.js